import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

import { SharedService } from 'baseline-lib';
import { Market } from 'baseline-lib';
import { Selection } from 'baseline-lib';
import { EventListing } from 'baseline-lib';
import { EventListingService } from 'baseline-lib';
import { VirtualListingService } from 'baseline-lib';

@Component({
  selector: 'app-sports-listing',
  templateUrl: 'sports-listing.html'
})
export class SportsListingComponent implements OnInit {

  @Input() eventId: number;

  EventListObj: EventListing;
  selected_mid : any = 0;

  constructor(
    private _virtualListingService: VirtualListingService,
    private _eventListingService: EventListingService,
    private _sharedService: SharedService
  ) {
    this.EventListObj = new EventListing();
  }

  ngOnInit() { }


  ngOnChanges(changes: SimpleChanges) {    
    if (changes.eventId) {
      this.eventId = changes.eventId.currentValue as number;
      this.EventListObj = this._eventListingService.EventListObj;
    }
  }


  // on click of odds selection
  BetSelection(_selection: Selection, market: Market) {

    this._virtualListingService.BetSelection(_selection, market, this.EventListObj.selectedEvent, this.EventListObj.gameObj);
  }

  
  on_expand(market){
    this.selected_mid = market.amid;
  }  


}


// WEBPACK FOOTER //
// ./src/app/virtual-sports/sports-listing/sports-listing.ts